import React from 'react';
import cn from 'clsx';
import { string, node } from 'prop-types';

/**
 * ModalFooter component.
 */
const Footer = ({
  className,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: cn('modal__footer', className)
}, children);
Footer.displayName = 'Modal.Footer';
Footer.defaultProps = {
  children: null,
  className: null
};
Footer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The modal footer */
  children: node,
  /** Additional class names to add to the component root. */
  className: string
} : {};
export default Footer;